const defaultPageSize = 200;

export {
    defaultPageSize,
};